module.exports = __webpack_public_path__ + "assets/img/3_1170_big.54a9d011.jpg";